export function changeRgbaColourTransparency(originalRgbaColour: string, targetOpacity: number) {
  return originalRgbaColour.replace(/ /g, '').replace(',1)', `,${targetOpacity})`)
}
